import { render, staticRenderFns } from "./zxrb.vue?vue&type=template&id=1564fe81&scoped=true"
import script from "./zxrb.vue?vue&type=script&lang=js"
export * from "./zxrb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564fe81",
  null
  
)

export default component.exports